import { Link } from 'react-router-dom';
import { Twitter, Github, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-background to-muted p-0.5 shadow-md">
                <img 
                  src="https://static.prod-images.emergentagent.com/jobs/d8a3ca16-6102-4289-b1d3-e802026d4bf5/images/679ce8c30dabaa92464bb2d013173cc342e4a01a6e6bb4cbb630fbbc2efb26bc.png"
                  alt="Bitcoin Atlas Logo"
                  className="w-full h-full object-contain rounded-full"
                />
              </div>
              <span className="font-bold text-lg">Bitcoin Atlas</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Educando pessoas sobre Bitcoin, autocustódia e soberania financeira.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Conteúdo</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/noticias" className="text-muted-foreground hover:text-foreground transition-colors">Notícias</Link></li>
              <li><Link to="/tutoriais" className="text-muted-foreground hover:text-foreground transition-colors">Tutoriais</Link></li>
              <li><Link to="/artigos" className="text-muted-foreground hover:text-foreground transition-colors">Artigos</Link></li>
              <li><Link to="/ferramentas" className="text-muted-foreground hover:text-foreground transition-colors">Ferramentas</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Sobre</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/comece-aqui" className="text-muted-foreground hover:text-foreground transition-colors">Comece Aqui</Link></li>
              <li><Link to="/sobre" className="text-muted-foreground hover:text-foreground transition-colors">Sobre Nós</Link></li>
              <li><Link to="/contato" className="text-muted-foreground hover:text-foreground transition-colors">Contato</Link></li>
              <li><Link to="/politica-de-privacidade" className="text-muted-foreground hover:text-foreground transition-colors">Política de Privacidade</Link></li>
              <li><Link to="/doar" className="text-muted-foreground hover:text-foreground transition-colors">Doar</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Redes Sociais</h3>
            <div className="flex gap-4">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="twitter-link">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="github-link">
                <Github size={20} />
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="linkedin-link">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>© 2025 Bitcoin Atlas. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};